import React from "react";
import ExpensesSubCategoriesComponent from "./ExpensesSubCategoriesComponent";
import {
  LIST_EXPCAT,
  LIST_EXPSUBCAT,
  UPDATE_EXPSUBCAT,
  
  DELETE_EXPSUBCAT,
} from "../../Network/ApiPaths";
import Uri from "../../Network/Uri";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";
let storeFresh;
let clientHost;
class ExpensesSubCategoriesContainer extends React.Component {
  constructor(props) {
    super();
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = JSON.parse(window.localStorage.getItem("clientAccess")).host;
    }
    this.state = {
      subCategories: [],
      categories: [],
      selectedCat: [],
      selectedCatId: "",
      selectedSubCatId: "",
      collapse: false,
      cName: "all",
      // onUpdateDetails: "",
      name: "",
      store: "",
      type: "",
      description: "",
      tax: "",
      itemDefaultDetails: "",
      itemDefaultPrices: "",
      newName: "",
      newStore: "",
      newType: "",
      newDesc: "",
      newTax: "",
      updatedName: "",
      updatedStore: "",
      updatedType: "",
      updatedDesc: "",
      updatedTax: "",
      dID: "",
      dPID: "",
      newPriceQuantity: "",
      newPriceMeasure: "",
      newPrice: "",
      newPriceOffer: "",
      newPID: "",
      priceQuantity: "",
      priceMeasure: "",
      pricePrice: "",
      priceOffer: "",
      new: false,
      editedCat: false,
      deletedSubCat: false,
      editCat:false,
    };
  }
  selectedCatID = (sCatId, sCatName) => {
    this.setState({
      selectedCatId: sCatId,
      cName: sCatName,
      collapse: true,
    });
    this.getSubCategories(sCatId);
  };
  next = (offset) => {
    if (this.state.selectedCatId === "") {
      this.setState({
        subCategories: [],
      });
    } else {
      var apiPath = new Uri(
        clientHost +
          `Expenses/listSubCategory?expenses_category_id=${this.state.selectedCatId}&limit=10&offset=${offset}`
      );
      getResponseClient(
        apiPath,
        (onSuccessResponse) => {
          this.setState({
            subCategories: onSuccessResponse.result,
          });
        },
        (onError) => {
          alert(onError.message);
        }
      );
    }
  };

  fieldChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    // this.setState({ [key]: e.target.value });
  };
  onUpdateDetails = (e) => {
    alert(
      this.state.itemDefaultDetails +
        this.state.updatedName +
        this.state.updatedStore +
        this.state.updatedType +
        this.state.updatedDesc +
        this.state.updatedTax
    );
  };

  onSubCategoryDelete = (e) => {
    var apiPath = new Uri(
      clientHost + `Expenses/deleteSubCategory?id=${this.state.dID}`
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        alert(onSuccessResponse);
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };

  onSubCategoryDetails = (e) => {
    console.log(e);
    // e.preventDefault();
    this.setState({
      itemDefaultDetails: e,
    });
  };
  onNameUpdate = (e) => {
    this.setState({ newName: e.target.value });
  };
  onAddNewSubCategory = () => {
    if (
      this.state.newName === "" ||
      this.state.newName === null ||
      this.state.newName === undefined
    ) {
      alert("Enter Name");
    } else {
      // let subCategoryDet = this.state.itemDefaultDetails;
      // POST API WITH DATA
      const requestBody = {
        expenses_category_id: this.state.selectedCatId,
        name: this.state.newName,
        
      };
      postClientDataResponse(
        clientHost + UPDATE_EXPSUBCAT,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.getSubCategories(this.state.selectedCatId);
        },
        (onError) => {
          console.log(onError);
        }
      );
    }
  };
  getSubCategories = (selectedCatId) => {
    var apiPath = new Uri(clientHost + LIST_EXPSUBCAT)
      // .addQueryParam("catId", selectedCatId)
      .addQueryParam("expenses_category_id",selectedCatId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        
        if (onSuccessResponse.status === true) {
        this.setState({
          subCategories: onSuccessResponse.result,
          // collapse: false,
          // new: true,
        });
        } else {
        this.setState({
          subCategories: onSuccessResponse.result,
          collapse: false,
          new: true,
        });
            }
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  // getSubCategories = (sid) => {
  //   var apiPath = new Uri(clientHost + SUBCATEGORY_LIST)
  //     .addQueryParam("catId", sid)
  //     .addQueryParam("store_id", storeFresh.storeId);
  //   getResponseClient(
  //     apiPath,
  //     storeFresh.key,
  //     (onSuccessResponse) => {
  //       this.setState({
  //         categories:onSuccessResponse.result.filter(
  //           (q) => q.info.category_id === sid),
  //         subCategories:onSuccessResponse.result.filter(
  //           (q) => q.info.category_id === sid),
  //             collapse:false,
  //             new:true,
  //       })

  //     },
  //     (onError) => {
  //       console.log(onError.message);
  //     }
  //   );
  // };
  onSubCategoryTriggerEdit = (p) => {
    this.setState({
      selectedCat: p,
    });
  };
  editCat = (c) => {
    if (
      this.state.newName === "" ||
      this.state.newName === this.state.selectedCat.name
    ) {
      alert("no changes to update");
    } else {
      let cid = this.state.selectedCat;
      const requestBody = {
        name: this.state.newName,
        addon_status: "ACTIVE",
        store_id: storeFresh.storeId,
        id: cid.id,
      };
      postClientDataResponse(
        clientHost + UPDATE_EXPSUBCAT,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            editedCat: true,
          });
          this.getSubCategories(this.state.selectedCatId);
        },
        (onError) => {
          console.log(onError);
        }
      );
    }
  };

  // editCat = (c) => {
  //   if (
  //     this.state.newName === "" ||
  //     this.state.newName === this.state.selectedCat.name
  //   ) {
  //     alert("no changes to update");
  //   } else {
  //     let cid = this.state.selectedCatId;
  //     const requestBody = {
  //       name: this.state.newName,
  //       addon_status: "ACTIVE",
  //       store_id: storeFresh.storeId,
  //       id: cid.id,
  //     };
  //     postClientDataResponse(
  //       clientHost + UPDATE_EXPSUBCAT,
  //       storeFresh.key,
  //       requestBody,
  //       (onSuccessResponse) => {
  //         this.setState({
  //           editedCat: true,
  //         });
  //         this.getSubCategories(this.state.selectedCatId);
  //       },
  //       (onError) => {
  //         console.log(onError);
  //       }
  //     );
  //   }
  // };
  onSubCategoryTriggerDelete = (e) => {
    this.setState({
      dID: e,
    });
  };
  deleteSubCat = (e) => {
    this.setState({
      SubCatDeleted: true,
    });
    var apiPath = new Uri(clientHost + DELETE_EXPSUBCAT).addQueryParam(
      "id",
      this.state.dID
    );
    // .addQueryParam(
    //   this.state.dID )
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        // this.setState({
        //   deletedCat: true,
        // });
        this.getSubCategories(this.state.selectedCatId);
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  render() {
    return (
      <div>
        {/* {test} */}
        <ExpensesSubCategoriesComponent
          data={this.state.subCategories}
          catData={this.state.categories}
          selectedCat={this.selectedCatID}
          catId={this.state.selectedCatId}
          cname={this.state.cName}
          collapse={this.state.collapse}
          next={this.next}
          fieldChange={this.fieldChange}
          onUpdateDetails={this.onUpdateDetails}
          onSubCategoryDetails={this.onSubCategoryDetails}
          onSubCategoryDelete={this.onSubCategoryDelete}
          subDefaultDetails={this.state.itemDefaultDetails}
          addNewSubCategory={this.onAddNewSubCategory}
          onSubCategoryTriggerEdit={this.onSubCategoryTriggerEdit}
          onSubCategoryTriggerDelete={this.onSubCategoryTriggerDelete}
          new={this.state.new}
          deletedSubCat={this.deletedSubCat}
          deleteSubCat={this.deleteSubCat}
          update={this.editCat}
          onNameUpdate={this.onNameUpdate}
          editedCat={this.state.editedCat}
        />
      </div>
    );
  }
  async componentDidMount() {
    var apiPath = new Uri(clientHost + LIST_EXPCAT).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        this.setState({
          categories: onSuccessResponse.result,
        });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  }
}

export default ExpensesSubCategoriesContainer;
